import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = {
  free_shipping_threshold: 2000,
  shipping_fee: 49,
  outside_zone_fee: 98,
  allowed_cities: ["Delhi NCR"],
  gift_box_price: 549,
  bulk_box_price: 999,
  announcement_lines: [
    "Free delivery in Delhi NCR on orders above Rs. 2000",
    "100% Organic Cold-Pressed Mustard Oil",
    "Homemade in Small Batches",
    "No Chemical Preservatives",
  ],
  delivery_note: "We currently deliver across Delhi NCR (Delhi, Noida, Gurgaon, Ghaziabad, Faridabad).",
  brand_email: "hello@dadusachaar.com",
  brand_phone: "",
  hero_image_url: "",
  instagram_url: "",
  facebook_url: "",
};

const SettingsContext = createContext(DEFAULTS);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = async () => {
    try {
      const r = await api.get("/settings");
      setSettings({ ...DEFAULTS, ...r.data });
    } catch {
      // fall back to defaults
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <SettingsContext.Provider value={{ ...settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
